import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API } from '@app-core/constants/api.constants';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root', // This ensures the service is a singleton
})
export class SuprsendService {
  constructor(private http: HttpClient, private router: Router) {}

  public getsuprsendDistinctId() {
    return this.http.get(API.SUPRSEND_DETAILS);
  }

  // Define dark theme configuration
  public darkThemeConfig = {
    bell: { color: '#fff' },
    badge: { backgroundColor: '#2E70E8', color: '#fff' },
    header: {
      container: { backgroundColor: '#303030', borderBottom: '0.5px solid #424242' },
      headerText: { color: '#fff' },
    },
    tabs: {
      color: '#EFEFEF',
      unselectedColor: '#CBD5E1D9',
      bottomColor: '#2E70E8',
      badgeColor: 'rgba(100, 116, 139, 0.5)',
      badgeText: '#EFEFEF',
    },
    notificationsContainer: {
      container: { backgroundColor: '#303030', borderColor: '#424242' },
      noNotificationsText: { color: '#EFEFEF' },
      noNotificationsSubtext: { color: '#CBD5E1' },
      loader: { color: '#2E70E8' },
    },
    notification: {
      avatar: {
        height: 27,
        width: 27,
      },
      container: {
        borderBottom: '1px solid #424242',
        readBackgroundColor: '#303030',
        unreadBackgroundColor: '#424242',
        hoverBackgroundColor: '#2D3A4D',
      },
      pinnedText: { color: '#CBD5E1' },
      pinnedIcon: { color: 'red' },
      headerText: { color: '#EFEFEF' },
      bodyText: { color: '#CBD5E1', blockquoteColor: 'rgba(100, 116, 139, 0.5)' },
      unseenDot: { backgroundColor: '#2E70E8' },
      createdOnText: { color: '#CBD5E1' },
      subtext: { color: '#94a3b8' },
      actions: [
        { container: { backgroundColor: '#2E70E8' } },
        {
          container: {
            borderColor: '#424242',
            backgroundColor: 'transparent',
            hoverBackgroundColor: '#303030',
          },
          text: { color: '#CBD5E1' },
        },
      ],
      expiresText: {
        backgroundColor: 'rgba(100, 116, 139, 0.5)',
        color: '#CBD5E1',
        expiringBackgroundColor: 'rgba(217, 45, 32, 0.15)',
        expiringColor: '#F97066',
      },
      actionsMenuIcon: {
        color: '#CBD5E1',
        hoverBackgroundColor: 'rgba(100, 116, 139, 0.5)',
      },
      actionsMenu: {
        backgroundColor: '#303030',
        borderColor: '#424242',
      },
      actionsMenuItem: { hoverBackgroundColor: 'rgba(100, 116, 139, 0.2)' },
      actionsMenuItemIcon: { color: '#CBD5E1' },
      actionsMenuItemText: { color: '#CBD5E1' },
    },
    toast: {
      container: { backgroundColor: '#303030', borderColor: '#424242' },
      headerText: { color: '#EFEFEF' },
      bodyText: { color: '#CBD5E1', blockquoteColor: '#424242' },
    },
  };

  public lightThemeConfig = {
    notification: {
      avatar: {
        height: 27,
        width: 27,
      },
    },
  };

  public injectDarkThemeStyles(): void {
    const styleId = 'suprsend-dark-theme-style';

    // Prevent duplicate style injection
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.innerHTML = `
    .css-1nj9hdi {
      color: white !important;
    }
    .css-2n6xng p {
      color: white !important;
    }
    .material-settings-button .material-icons {
      color: white !important;
    }
    .css-93hjs0 {
    color: white !important;
    }
    .css-1x6redj{
     filter: brightness(0) invert(1);
    }
  `;
    document.head.appendChild(style);
  }

  public removeDarkThemeStyles(): void {
    const style = document.getElementById('suprsend-dark-theme-style');
    if (style) style.remove();
  }

  public cleanupInboxModal(): void {
    const inboxContainer = document.querySelector('[data-popper-placement="bottom"]');
    if (inboxContainer) {
      inboxContainer.remove();
    }
  }

  public waitForModalThenAddButton(): void {
    const interval = setInterval(() => {
      const inboxModal = document.querySelector('.css-294qun') || document.querySelector('.css-1wyxcjl');

      // Check if modal is visible and our button isn't there yet
      if (inboxModal && getComputedStyle(inboxModal).display !== 'none' && !document.getElementById('notification-settings-link')) {
        this.addNotificationSettingsLink(inboxModal);
        clearInterval(interval);
      }
    }, 100);

    // Auto-stop after 5 seconds to avoid infinite polling
    setTimeout(() => clearInterval(interval), 5000);
  }

  public addNotificationSettingsLink(inboxModal: Element): void {
    const btn = document.createElement('button');
    btn.id = 'notification-settings-link';
    btn.classList.add('notification-button', 'material-settings-button');

    // Add the Material Icon
    btn.innerHTML = `<span class="material-icons">settings</span>`;
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.cleanupInboxModal();
      this.router.navigate(['/notification-setting']);
    });

    const markAllButton = inboxModal.querySelector('.css-1hwxpac');
    if (markAllButton) {
      (markAllButton as HTMLElement).style.display = 'flex';
      (markAllButton as HTMLElement).style.justifyContent = 'space-between';
      markAllButton.appendChild(btn);
    }
  }
}
